/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-03-10 14:08:21
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-05-13 18:56:06
 * @Description: file content
 */
window.util = {
  randomNum(minNum, maxNum) {
    switch (arguments.length) {
      case 1:
        return parseInt(Math.random() * minNum + 1, 10);
      case 2:
        return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
      default:
        return 0;
    }
  }
}